"use client";

import {
  OPUS_BITRATE_BPS,
  OPUS_TARGET_CHANNELS,
  OPUS_TARGET_SAMPLE_RATE_HZ,
} from "@/constants/audioQuality";
import { encodeToOpusOrWavFile } from "@/utils/audio/encodeToOpusOrWavFile";

// The pitch-analysis clip only needs to survive pitch tracking, so it is downsampled to 16 kHz mono at a low bitrate to keep mobile uploads small. WAV at the same format is ~10x larger but still mobile-friendly.
export const audioBufferToPitchAnalysisFile = async (
  audioBuffer: AudioBuffer,
  baseFileName: string
): Promise<File> => {
  return encodeToOpusOrWavFile({
    audioBuffer,
    baseFileName,
    targetFormat: {
      sampleRate: OPUS_TARGET_SAMPLE_RATE_HZ,
      numberOfChannels: OPUS_TARGET_CHANNELS,
    },
    bitrate: OPUS_BITRATE_BPS,
  });
};
